import * as yup from 'yup';

export const uploadProfilePictureSchema = yup.object().shape({
  fileName: yup.mixed().required('You need to provide a file'),
  // .test(2500, 'File Size is too large', (value) => value.size <= 2500),
});
